export enum SearchOrder {
  CODE = "CODE",
  MODIFIED_ON = "MODIFIED_ON",
}
